export default "__VITE_ASSET__cWLJRN7o__"